import { Box, styled } from '@mui/material';

const StyledDrawerMenuLogoutContainer = styled(Box)(() => ({
  paddingBottom: '27px',
  paddingLeft: '20px'
}));

export default StyledDrawerMenuLogoutContainer;
